import { Action } from "@ngrx/store";
import { studentDataSearch, View } from "./state";

export const GET_STUDENT_DATA = "GET_STUDENT_DATA";
export const GET_STUDENT_DATA_SUCCESS = "GET_STUDENT_DATA_SUCCESS";
export const GET_STUDENT_DATA_ERROR = "GET_STUDENT_DATA_ERROR";
export const SELECT_STUDENT = "SELECT_STUDENT";
export const SELECT_ALL_STUDENTS = "SELECT_ALL_STUDENTS";
export const UPDATE_SELECTED_VIEW = "UPDATE_SELECTED_VIEW";

export class GetStudentDataAction implements Action {
  readonly type = GET_STUDENT_DATA;
  constructor(public payload: studentDataSearch) {}
}

export class SelectStudentAction implements Action {
  readonly type = SELECT_STUDENT;
  constructor(public payload: number) {}
}

export class SelectAllStudentsAction implements Action {
  readonly type = SELECT_ALL_STUDENTS;
  constructor(public payload: boolean) {}
}

export class UpdateSelectedViewId implements Action {
  readonly type = UPDATE_SELECTED_VIEW;
  constructor(public payload: number) {}
}

export type Actions = GetStudentDataAction;
